"use strict";
var $ = require("../internals/export");
var iterate = require("../internals/iterate");
var createProperty = require("../internals/create-property");
$({ target: "Object", stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function(k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});
